import {z} from 'zod'
import {
  ClientUserStatsSchema,
  InviteUserSchema,
  UpdateUserSchema,
  UserSchema,
  UsersPaginated,
} from '../schemas/user.schemas'

export type TUser = z.infer<typeof UserSchema>

export enum ELang {
  fr = 'fr',
  en = 'en',
}
export enum ERole {
  VIEWER = 'VIEWER',
  REQUESTOR = 'REQUESTOR',
  OPC = 'OPC',
  ADMIN = 'ADMIN',
}

export type TNetworkRole = {
  networkId: string
  role: ERole
}

// User-list sorting & filtering (mirrors the API querystring contract).
export type TUserSortBy = 'name' | 'email' | 'role'
export type TSortOrder = 'asc' | 'desc'
export type TActivationFilter = 'activated' | 'pending'

export type TUsersPaginated = z.infer<typeof UsersPaginated>

export type TClientUserStats = z.infer<typeof ClientUserStatsSchema>

export type TInviteUser = z.infer<typeof InviteUserSchema>

export type TUpdateUser = z.infer<typeof UpdateUserSchema>
